import { api } from "@/comn";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { TFormSchema, TGridSchema, useFetch } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";

/*
 * Survey Statistics Service
 * !== 설문 통계 서비스 ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */

export const BASE = {
    path: `${ptlEnvs.base}/surv/ststcl`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/surv/ststcl`,
    api_mng: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/surv/qustnr`,
    nodes: [],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli0422001q: `${BASE.path}/ptli0422001q`,
    ptli0422002q: `${BASE.path}/ptli0422002q`,
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    getSurvInfo: (id: any) => {
        return api.get(`${BASE.api_mng}/${id}`);
    },
    getSurvMgmtList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api_mng}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    getSurvStstclList: (data: any) => {
        return api.get(`${BASE.api}`, {
            params: comnUtils.toGetParams(data),
        });
    },
};

export const SF_SURV_MGMT_LIST_SRCH: TFormSchema = {
    id: "form_SurvMgmtListSrch",
    schema: {
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_CD",
            all: true,
            area: "comnCd",
            comnCd: "COM0024",
            required: true,
        },
        ptlTpCd: {
            required: true,
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "COM0052",
            excludes: ["B"],
            editType: "both",
        },
        qustnrTtle: { type: "text", label: "L_QUSTNR_TTLE" },
        reqDateRnge: {
            type: "daterange",
            label: "L_RGST_DT",
            start: { name: "qustnrStrtDt" },
            end: { name: "qustnrEndDt" },
            rangeButton: 4,
        },
    },
};

export const SF_SURV_INFO: TFormSchema = {
    id: "form_survInfo",
    schema: {
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_CD",
            all: true,
            area: "comnCd",
            comnCd: "COM0024",
            required: true,
        },
        ptlTpCd: {
            required: true,
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "COM0052",
            excludes: ["B"],
            editType: "both",
        },
        mnPgeQustnrYn: {
            type: "radio",
            label: "L_MN_PGE_QUSTNR_YN",
            required: true,
            area: "comnCd",
            comnCd: "PTL0062",
        },
        qustnrTtle: { type: "text", label: "L_QUSTNR_TTLE" },
        qustnrPupsCn: { type: "text", label: "L_QUSTNR_PUPS_CN" },
        qustnrMakeInfoCn: { type: "text", label: "L_QUSTNR_MAKE_INFO_CN" },
        qustnrTrgtAcrdtYn: {
            type: "radio",
            label: "L_QUSTNR_TRGT_ACRDT_YN",
             area: "comnCd",
             comnCd: "PTL0063",
            // options: [
            //     { label: "User", value: "1" },
            //     { label: "non-User", value: "2" },
            // ],
            defaultValue: "1",
            required: true,
        },  // comnCd 생성 필요 (회원 / 비회원)
        reqDateRnge: {
            type: "daterange",
            label: "L_RQST_DT",
            start: { name: "qustnrStrtDt" },
            end: { name: "qustnrEndDt" },
            rangeButton: 4,
        },
    },
};

export const SG_SURV_MGMT_LIST: TGridSchema = {
    id: "grid_SurvMgmtList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_QUSTNR_TTLE", binding: "qustnrTtle", width: "*" }] },
        { cells: [{ header: "L_QUSTNR_STRT_DT", binding: "qustnrStrtDt", width: "*" }] },
        { cells: [{ header: "L_QUSTNR_END_DT", binding: "qustnrEndDt", width: "*" }] },
        { cells: [{ header: "L_BSOP_CLSF_CD", binding: "bsopClsfCdNm", width: "*" }] },
        { cells: [{ header: "L_PTL_TP_CD", binding: "ptlTpCdNm", width: "*" }] },
        { cells: [{ header: "L_FRST_REGST_ID", binding: "frstRegstId", width: "*" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "15%" }] },
    ],
    body: [
        { cells: [{ binding: "qustnrTtle", align: "left" }] },
        { cells: [{ binding: "qustnrStrtDt", align: "center" }] },
        { cells: [{ binding: "qustnrEndDt", align: "center" }] },
        { cells: [{ binding: "bsopClsfCdNm", align: "center" }] },
        { cells: [{ binding: "ptlTpCdNm", align: "center" }] },
        { cells: [{ binding: "frstRegstId", align: "center" }] },
        { cells: [{ binding: "frstRgsrDtm", type: "datetime" }] },
    ],
};

export const SF_SURV_STSTCL_INFO: TFormSchema = {
    id: "form_survInfo",
    schema: {
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_CD",
            all: true,
            area: "comnCd",
            comnCd: "COM0024",
            required: true,
        },
        ptlTpCd: {
            required: true,
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "COM0052",
            excludes: ["B"],
            editType: "both",
        },
        qustnrTtle: { type: "text", label: "L_QUSTNR_TTLE" },
        qustnrPupsCn: { type: "text", label: "L_QUSTNR_PUPS_CN" },
        reqDateRnge: {
            type: "daterange",
            label: "L_RQST_DT",
            start: { name: "qustnrStrtDt" },
            end: { name: "qustnrEndDt" },
            rangeButton: 4,
        },
    },
};

export const SG_SURV_STSTCL_LIST: TGridSchema = {
    id: "grid_SurvStstclList",
    options: { index: false, height: 250 },
    head: [
        { cells: [{ header: "L_ITM_CN", binding: "itmCn", width: "*" }] },
        { cells: [{ header: "L_RSPN_CNT", binding: "rspnCnt", width: "*" }] },
        { cells: [{ header: "L_RSPN_PCT", binding: "rspnPer", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "itmCn", align: "left" }] },
        { cells: [{ binding: "rspnCnt", align: "center" }] },
        { cells: [{ binding: "rspnPer", align: "center" }] },
    ],
};

export const SG_SURV_STSTCL_SUB_LIST: TGridSchema = {
    id: "grid_SurvStstclSubList",
    options: { index: false },
    head: [{ cells: [{ header: "L_ANSWR", binding: "othrCn", width: "*" }] }],
    body: [{ cells: [{ binding: "othrCn", align: "left" }] }],
};
